import type { UseQueryResult } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import * as echarts from 'echarts/core'

const WORLD_MAP_NAME = 'worldMap'

/**
 * The world map outline the ECharts country maps draw on, registered under `worldMap`. Registered here, once
 * per fetch, rather than by each map: registering parses the whole outline and drops ECharts' cache of parsed
 * countries. The file never changes, so it is kept for the whole session.
 */
export const useWorldMap = (): UseQueryResult<string> =>
  useQuery({
    queryKey: ['map'],
    queryFn: async () => {
      const worldMap = await fetch('/world-map-light.json').then(response => response.text())
      echarts.registerMap(WORLD_MAP_NAME, worldMap)
      return worldMap
    },
    staleTime: Infinity,
    gcTime: Infinity,
  })
